import React from 'react';
import { fromUnixTime } from 'date-fns';
import { PersonalizedBlock } from 'helper/personalized';
import useControlPanelOptions from 'utils/hooks/meteorology/useControlPanelOptions';
import BlockDisplay from 'components/Flux/Personalized/BlockDisplay';
import './index.scss';

const safeDate = (timestamp: number | null | undefined): string => (
  timestamp ? fromUnixTime(timestamp).toLocaleDateString('pt-BR') : ''
);

const formatRuntime = (runtime: string | null | undefined): string | null => {
  if (!runtime && runtime !== '0') return null;
  return `UTC-${runtime}`;
};

export default function Block({ block, index }: {
  block: PersonalizedBlock,
  index: number
}) {
  const { getModelOptions } = useControlPanelOptions('flux');
  const modelOptions = getModelOptions(block.ds_modelo);
  const memberLabel = modelOptions.members.find(
    (m) => m.id === block.membro,
  )?.label || block.membro;

  const forecastDate = safeDate(block.dt_data_prev);
  const startDate = safeDate(block.dt_inicio);
  const endDate = safeDate(block.dt_fim);
  const sliceStartDate = safeDate(block.dt_recorte_inicio);
  const sliceEndDate = safeDate(block.dt_recorte_fim);

  return (
    <BlockDisplay
      title={`Bloco ${index + 1}`}
      model={block.ds_modelo?.toUpperCase()}
      forecastDate={forecastDate}
      rmv={block.ck_rmv}
      startDate={startDate}
      endDate={endDate}
      sliceStartDate={sliceStartDate}
      sliceEndDate={sliceEndDate}
      runtime={formatRuntime(block.run_time)}
      member={memberLabel}
    />
  );
}
